export default {
  CUSTOMER: 'CUSTOMER',
  DISTRIBUTION_CENTER: 'DISTRIBUTION_CENTER',
  INTERNAL: 'INTERNAL'
};
